import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { TValidSdcColumns } from './../../sdc-columns.type';
import { DEFAULT_SORT } from './../default-sort.constant';
import { SdcStateServiceBaseModel } from './../sdc-state-basemodel';
import { sdcStateConfigConstant } from './../sdc-state-config.constant';
import {
  IColumnSort,
  IFilter,
  IGridViews,
  ISdcActivity,
  TValidSdcStates,
  TValidSdcViews,
} from './../sdc-state.typings';

export class MarkingPeriodConfigService extends SdcStateServiceBaseModel implements ISdcActivity {
  static $inject = ['ImSchool'];

  constructor(private ImSchool: ImSchool) {
    super();
  }

  get humanName() {
    return sdcStateConfigConstant.MARKING_PERIOD.humanName;
  }

  get state(): TValidSdcStates {
    return sdcStateConfigConstant.MARKING_PERIOD.state;
  }

  get columns(): TValidSdcColumns[] {
    return [
      'studentId',
      'studentName',
      'cohort',
      'seniorFlag',
      'status',
      'grade',
      'officialClass',
      'atsCounselor',
      'advisor',
      'iep',
      'ell',
      'attendanceYtd',
      'gradPlan',
      'currentCourses',
      'currentCourseCodes',
      'currentTeachers',

      // marking period columns
      'countOfCoursesFailingMostRecentMp',
      'countOfHighPriorityCoursesFailingMostRecentMp',

      // regents planning columns
      'transcriptGradeAverage',
      'currentlyActiveSupports',
      'regentsPassedForDiploma',
      'regentsNeededForOnTrackDiploma',

      // credit gaps columns
      'subjectsWithCreditGaps',
      'creditMaxGaps',

      'totalCountOfGradThreats',
      'attdThreat',
      'courseFailureThreat',
      'creditGapsThreat',
      'regentsThreat',

      // added for community schools on 3/22
      'schoolPriorityFlag',
    ];
  }

  get hiddenColumns(): TValidSdcColumns[] {
    return [];
  }

  get gridViews(): IGridViews {
    return {};
  }

  get filter(): IFilter {
    const school = this.getSchool();

    const filter: IFilter = {
      status: ['A'],
    };

    // Transfer schools should not be filtered by cohort
    const isTransfer = this.ImSchool.isTransferSchool(school);
    if (isTransfer) return filter;

    const seniorAndSuperCohorts = this.ImSchool.getSeniorAndSuperCohorts(school);

    let mostSeniorCohort;
    if (seniorAndSuperCohorts.length === 0) {
      mostSeniorCohort = _.min(school.uniqueCohorts);
    }

    // Otherwise return either senior + super senior cohorts, or the single most senior cohort
    const cohort = _.size(seniorAndSuperCohorts) ? seniorAndSuperCohorts : [mostSeniorCohort];

    filter.cohort = cohort;

    return filter;
  }

  get sort(): IColumnSort[] {
    return DEFAULT_SORT;
  }

  get bundleName() {
    return 'MARKING_PERIOD';
  }

  get availableSdcViews(): TValidSdcViews[] {
    return sdcStateConfigConstant.MARKING_PERIOD.availableSdcViews;
  }
}
